// extracted by mini-css-extract-plugin
export var header = "header-module--header--1cAWy";
export var rightBlock = "header-module--rightBlock--3g1Da";
export var mobile = "header-module--mobile--3jDS0";
export var orderService = "header-module--orderService--1yaUs";
export var buttonContact = "header-module--buttonContact--1nGJV";
export var logoIcon = "header-module--logoIcon--OORBR";